module.exports = __webpack_public_path__ + "img/drag-to-answer-white.64d49f78.png";